import React from "react";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom"; // Added import for navigation and location
import { LOCALES } from "common/constants";
const InvoiceFilter = ({
  t,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleFilterInvoice,
  setactivePagination,
  handleClearFilter,
  loading,
  invoiceNumber,
}) => {
  const navigate = useNavigate(); // Initialize navigation
  const location = useLocation(); // Initialize location to get current URL
  
  // Extract language from current URL
  const getCurrentLang = () => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get('lang');
    
    if (langParam === 'sv-se') return LOCALES.SV_SE;
    if (langParam === 'en-us') return LOCALES.EN_US;
    return LOCALES.SV_SE; // Default to Swedish
  };

  // Get the appropriate URL based on language
  const getInvoiceToolUrl = () => {
    const currentLang = getCurrentLang();
    
    if (currentLang === LOCALES.EN_US) {
      return `/dashboard/invoice-tool?lang=en-us`;
    } else {
      return `/instrumentbrada/faktura-verktyg?lang=sv-se`;
    }
  };

  return (
    <div>
      <div className="row m-0 mb-2 invoices-row">
        <div className="col-md-8 col-sm-12 d-flex flex-wrap align-items-center">
          <div className="col-md-3 pl-0 col-sm-6 mb-2">
            <DatePicker
              render={
                <InputIcon
                  placeholder={t("From")}
                  style={{
                    border:
                      !loading && fromDate > toDate ? "1px solid #dc3545" : "",
                  }}
                />
              }
              value={fromDate}
              onChange={(date) => {
                setFromDate(new Date(date));
                if (!toDate) {
                  setToDate(new Date());
                }
              }}
            />
            {!loading && fromDate > toDate && (
              <p
                className="form-text text-danger mb-0 ml-1"
                style={{ fontSize: "0.8rem" }}
              >
                {t("End date must be higher than start date")}
              </p>
            )}
            {!loading && toDate && !fromDate && (
              <p
                className="form-text text-danger mb-0 ml-1"
                style={{ fontSize: "0.8rem" }}
              >
                {t("Please Select The Start Date")}
              </p>
            )}
          </div>

          <div className="col-md-3 pl-0 col-sm-6 mb-2">
            <DatePicker
              color="red"
              render={<InputIcon placeholder={t("To")} />}
              value={toDate}
              className="ml-2"
              onChange={(date) => {
                setToDate(new Date(date));
              }}
            />
          </div>

          <Button
            variant="outline-primary"
            className="mb-2 h-90"
            onClick={() => {
              handleFilterInvoice();
              setactivePagination(1);
            }}
          >
            {t("Search")}
          </Button>

          <Button
            disabled={!invoiceNumber && (!fromDate && !toDate)}
            variant="outline-primary"
            className="mb-2 ml-2 h-90"
            onClick={() => {
              handleClearFilter();
              setactivePagination(1);
            }}
          >
            {t("Clear Filters")}
          </Button>
        </div>

        <div className="col-md-4 col-sm-12 text-right">
          <Button
            variant="primary"
            className="mb-2 ml-2 h-90"
            onClick={() => navigate(getInvoiceToolUrl())}
          >
            {t("Create Invoice")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFilter;
